import styled from '@emotion/styled'
import * as React from 'react'

type TProps = Children & {
  /**
   * URL used as a `href` of the `<a>` element
   */
  url: string
  /**
   * `target` attribute of the `<a>` element
   */
  target?: React.HTMLAttributeAnchorTarget
  /**
   * Callback called when the link is clicked
   */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const StyledWebLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

/**
 * Wrap web page URLs in this component to make them into a clickable links.
 *
 * If no children are provided, the `url` is rendered.
 */
export const WebLink: React.FC<TProps> = ({ children, url, target = `_blank`, onClick }) => {
  return (
    <StyledWebLink href={url} target={target} onClick={onClick}>
      {children ?? url}
    </StyledWebLink>
  )
}
